import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';

import {AppComponent} from './app.component';
import {AppRoutingModule} from "./routing.module";
import {DashboardComponent} from './dashboard/dashboard.component';
import {UsersComponent} from './users/users.component';
import {CompaniesComponent} from './companies/companies.component';
import {SettingsComponent} from './settings/settings.component';
import {UserAddComponent} from "./users/user-add.component";
import {UserEditComponent} from "./users/user-edit.component";
import {CompanyStatusComponent} from "./company-status/company-status.component";
import {CompanyAddComponent} from "./companies/company-add.component";
import {CompanyEditComponent} from "./companies/company-edit.component";
import {CompanyStatusAddComponent} from "./company-status/company-status-add.component";
import {CompanyStatusEditComponent} from "./company-status/company-status-edit.component";
import { CompanyDetailComponent } from './company-detail/company-detail.component';
import { SettingAddComponent } from './settings/setting-add.component';
import { SettingEditComponent } from './settings/setting-edit.component';
import { UserRolesComponent } from './user-roles/user-roles.component';
import { UserRoleAddComponent } from './user-roles/user-role-add.component';
import { UserRoleEditComponent } from './user-roles/user-role-edit.component';
import { CompanyImportComponent } from './company-import/company-import.component';
import { CompanyCategoryComponent } from './company-category/company-category.component';
import { CompanyCategoryAddComponent } from './company-category/company-category-add.component';
import { PaginationComponent } from './shared/pagination/pagination.component';
import {AuthGuardService} from "./services/auth-guard.service";
import { LoginComponent } from './login/login.component';
import {AuthService} from "./services/auth.service";
import { MyDatePickerModule } from 'mydatepicker';
import {ApiService} from "./services/api.service";
import {AuthModule} from "./auth/auth.module";
import { CompanyCategoryEditComponent } from './company-category/company-category-edit.component';
import {DataService} from "./services/data.service";
import {Ng2Bs3ModalModule} from "ng2-bs3-modal/ng2-bs3-modal";
import {MomentModule} from "angular2-moment";
import { CompanyExportComponent } from './company-export/company-export.component';
import {MailchimpListComponent} from "./mailchimp/mailchimp-list.component";
import {MailchimpListEditComponent} from "./mailchimp/mailchimp-list-edit.component";
import { CompanyVisaStatusComponent } from './company-visa-status/company-visa-status.component';
import { CompanyVisaStatusAddComponent } from './company-visa-status/company-visa-status-add.component';
import { CompanyVisaStatusEditComponent } from './company-visa-status/company-visa-status-edit.component';
import { CompanyVisaComponent } from './company-visa/company-visa.component';
import { CompanyVisaAddComponent } from './company-visa/company-visa-add.component';
import { CompanyVisaEditComponent } from './company-visa/company-visa-edit.component';
import {AutoCompleteModule} from 'primeng/primeng';

@NgModule({
    declarations: [
        AppComponent,
        DashboardComponent,
        UsersComponent,
        UserRolesComponent,
        CompaniesComponent,
        CompanyStatusComponent,
        SettingsComponent,
        UserAddComponent,
        UserEditComponent,
        CompanyAddComponent,
        CompanyEditComponent,
        CompanyStatusComponent,
        CompanyVisaComponent,
        CompanyVisaAddComponent,
        CompanyVisaEditComponent,
        CompanyVisaStatusComponent,
        CompanyVisaStatusAddComponent,
        CompanyVisaStatusEditComponent,
        CompanyStatusAddComponent,
        CompanyStatusEditComponent,
        CompanyDetailComponent,
        SettingAddComponent,
        SettingEditComponent,
        UserRolesComponent,
        UserRoleAddComponent,
        UserRoleEditComponent,
        CompanyImportComponent,
        CompanyCategoryComponent,
        CompanyCategoryAddComponent,
        PaginationComponent,
        LoginComponent,
        CompanyCategoryEditComponent,
        CompanyExportComponent,
        MailchimpListComponent,
        MailchimpListEditComponent,
        CompanyVisaStatusComponent,
        CompanyVisaComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        AppRoutingModule,
        AuthModule,
        MyDatePickerModule,
        Ng2Bs3ModalModule,
        MomentModule,
        AutoCompleteModule
    ],
    providers: [
        ApiService,
        AuthGuardService,
        AuthService,
        DataService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts